import { useState } from 'react';
import { IoMdCloudUpload } from 'react-icons/io';
//import components
import SubPagesLayout from 'layouts/SubPagesLayout';
import Button from 'components/common/Button';
import TitleSection from 'components/common/TitleSection';

const CustomizePage = () => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'entertairment EVENTS',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  const initialValues = {
    name: '',
    projectType: '',
    email: '',
    phoneNumber: '',
    budget: '',
    file: '',
    eventDetail: '',
  };
  const [formValues, setFormValues] = useState(initialValues);

  const handleFormChange = (e) => {
    if (e.target.files) {
      setFormValues({
        ...formValues,
        [e.target.name]: e.target.files[0],
      });
    }
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <>
      <div className='getQuotePage DBlock py-12 sm:py-16 px-6 bg-eventLightPink '>
        <div className='max-w-6xl getQuote mx-auto'>
          <div
            style={{
              background: `url("/assets/images/what-we-do/customizeBg.png") no-repeat center/cover`,
            }}
            className='overflow-hidden shadow-lg rounded-xl bg-white dark:bg-black mx-auto'>
            <div className='px-6 sm:px-8 py-8 sm:py-12'>
              <TitleSection titleDetail={titleDetail} whiteText={true} />
            </div>
            <form
              onSubmit={handleSubmit}
              className='max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2  gap-4 sm:gap-10 px-6 sm:px-8 pb-8 sm:pb-12'>
              <div className='col-span-2 md:col-span-1'>
                <div>
                  <label
                    htmlFor='first-name'
                    className='mb-1.5 block text-sm text-white font-bold'>
                    Name
                  </label>
                  <input
                    onChange={handleFormChange}
                    required
                    type='text'
                    name='name'
                    id='first-name'
                    placeholder='Please enter your name'
                    autoComplete='name'
                    className=' block text-eventDarkYellow w-full rounded-full border-gray-300 bg-white  shadow-sm focus:border-eventLightYellow focus:ring-eventLightYellow hover:border-eventLightYellow hover:ring-eventLightYellow border-2 border-transparent text-xs lg:text-sm px-3 py-2.5 '
                  />
                </div>
                <div className='my-4'>
                  <label
                    htmlFor='email'
                    className='mb-1.5 block text-sm text-white font-bold'>
                    Email
                  </label>
                  <input
                    onChange={handleFormChange}
                    required
                    type='email'
                    name='email'
                    id='email'
                    placeholder='Please enter your EMAIL'
                    className=' block w-full text-eventDarkYellow rounded-full border-gray-300 bg-white  shadow-sm focus:border-eventLightYellow focus:ring-eventLightYellow hover:border-eventLightYellow hover:ring-eventLightYellow border-2 border-transparent text-xs lg:text-sm px-3 py-2.5 '
                  />
                </div>
                <div className='my-4'>
                  <label
                    htmlFor='phone-number'
                    className='mb-1.5 block text-sm text-white font-bold'>
                    Phone Number
                  </label>
                  <input
                    onChange={handleFormChange}
                    type='text'
                    name='phoneNumber'
                    id='phone-number'
                    placeholder='*********'
                    className=' block w-full text-eventDarkYellow rounded-full border-gray-300 bg-white  shadow-sm focus:border-eventLightYellow focus:ring-eventLightYellow hover:border-eventLightYellow hover:ring-eventLightYellow border-2 border-transparent text-xs lg:text-sm px-3 py-2.5 '
                  />
                </div>
              </div>
              <div className='col-span-2 md:col-span-1'>
                <div className='mb-4 relative'>
                  <label
                    htmlFor='projectType'
                    className='mb-1.5 block text-sm text-white font-bold'>
                    Looking for
                  </label>

                  <select
                    onChange={handleFormChange}
                    id='projectType'
                    name='projectType'
                    className=' block w-full rounded-full border-gray-300 text-eventGray font-medium bg-white  shadow-sm focus:border-eventLightYellow focus:ring-eventLightYellow hover:border-eventLightYellow hover:ring-eventLightYellow border-2 border-transparent text-xs lg:text-sm px-3 py-2.5'>
                    <option selected className='font-medium'>
                      Barat
                    </option>
                    <option className='font-medium'>BirthDay</option>
                    <option className='font-medium'>Walima</option>
                    <option className='font-medium'>Mehndi</option>
                  </select>
                </div>
                <div className='my-4'>
                  <label
                    htmlFor='budget'
                    className='mb-1.5 block text-sm text-white font-bold'>
                    Budget
                  </label>
                  <input
                    onChange={handleFormChange}
                    type='text'
                    name='budget'
                    id='budget'
                    placeholder='Write Your Mind'
                    autoComplete='name'
                    className=' block w-full text-eventDarkYellow rounded-full border-gray-300 bg-white  shadow-sm focus:border-eventLightYellow focus:ring-eventLightYellow hover:border-eventLightYellow hover:ring-eventLightYellow border-2 border-transparent text-xs lg:text-sm px-3 py-2.5 '
                  />
                </div>
                <div className='my-4' htmlFor='file-upload'>
                  <label className='block text-sm text-white font-bold'>
                    Attachment{' '}
                    <span className='text-eventLightYellow text-clBody2 ml-1 font-normal'>
                      Optional
                    </span>
                    <div className='relative  mt-1.5  block w-full rounded-full text-white border-gray-300  bg-white shadow-sm focus:border-eventLightYellow focus:ring-eventLightYellow hover:border-eventLightYellow hover:ring-eventLightYellow border-2 border-transparent text-xs lg:text-sm px-3 py-2.5'>
                      <input
                        onChange={handleFormChange}
                        type='file'
                        name='file'
                        id='file-upload'
                        accept='image/png, image/jpeg'
                        placeholder='Upload File'
                        className='hidden'
                      />
                      <div className='font-medium text-eventGray'>
                        Drag & drop files or{' '}
                        <span className='text-eventLightYellow cursor-pointer'>
                          {' '}
                          Browse{' '}
                        </span>
                      </div>
                      <span className='absolute cursor-pointer right-2 top-2 h-6 w-6 flex items-center justify-center rounded-full bg-eventLightYellow text-white'>
                        <IoMdCloudUpload />
                      </span>
                    </div>
                  </label>
                </div>
              </div>
              <div className='col-span-2 block w-full'>
                <label
                  htmlFor='eventDetail'
                  className='mb-1.5 block text-sm text-white  font-bold'>
                  Event Detail
                </label>
                <textarea
                  onChange={handleFormChange}
                  id='eventDetail'
                  name='eventDetail'
                  rows={5}
                  placeholder='Write Detail'
                  className=' block w-full text-eventDarkYellow rounded-md border-gray-300  bg-white shadow-sm focus:border-eventLightYellow focus:ring-eventLightYellow hover:border-eventLightYellow hover:ring-eventLightYellow border-2 border-transparent text-xs lg:text-sm px-3 py-2.5 '
                  defaultValue={''}
                />
                <button className='float-right mt-6' type='submit'>
                  <Button title='Submit' />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubPagesLayout({ route: 'what we do/customize event' })(
  CustomizePage
);
